/** The signature full stop belongs to the displayed heading, not its metadata. */
export function HeadingAccent({ children }: { children: string }) {
  const text = children.trimEnd();
  const ending = text.match(/([.!?…]+)([”’"')\]]*)$/);

  // Keep questions, exclamations and ellipses as authored.
  if (ending && ending[1] !== ".") return text;

  const heading = ending ? text.slice(0, -ending[0].length) : text;

  return (
    <>
      {heading}
      <span className="heading-accent-dot" aria-hidden={ending ? undefined : true}>
        .
      </span>
      {ending?.[2]}
    </>
  );
}
